import React, { useRef, useEffect } from 'react'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useTimeout } from 'usehooks-ts'
import { useIsMobile } from '../../hooks/useIsDesktop'
import { useIntersectionObserver, useIsomorphicLayoutEffect } from 'usehooks-ts'

if (typeof window !== 'undefined') {
  // Due to SSR we can only register when we are in the browser
  gsap.registerPlugin(ScrollTrigger)
}

type ParallaxProps = {
  children: any
}

const Parallax = (props: ParallaxProps) => {
  const parallaxRef = useRef<HTMLDivElement>(null)
  const parallaxInnerRef = useRef<HTMLDivElement>(null)
  const isMobile = useIsMobile()

  const entry = useIntersectionObserver(parallaxRef, {
    rootMargin: '200px',
    freezeOnceVisible: true
  })

  const isVisible = !!entry?.isIntersecting

  useIsomorphicLayoutEffect(() => {
    if (parallaxRef && parallaxRef.current) {
      const t1 = gsap.timeline({
        scrollTrigger: {
          trigger: parallaxRef.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.7,
        },
      })
      if (parallaxRef && parallaxRef.current) {
        t1.fromTo(
          parallaxInnerRef.current,
          {
            yPercent: () => (isMobile ? 10 : 30),
          },
          {
            yPercent: () => (isMobile ? -10 : -25),
            duration: 1,
            ease: 'linear',
          }
        )
      }
      return () => {
        t1 && t1.kill()
      }
    }
  }, [parallaxRef, parallaxInnerRef, isMobile])

  useIsomorphicLayoutEffect(() => {
    ScrollTrigger.refresh()
  }, [isVisible])

  useTimeout(() => {
    ScrollTrigger.refresh()
  }, 1000)

  return (
    <div ref={parallaxRef}>
      <div ref={parallaxInnerRef}>{props.children}</div>
    </div>
  )
}

export default Parallax
